import { render } from "./ToggleCard.vue?vue&type=template&id=be867d4a&scoped=true"
import script from "./ToggleCard.vue?vue&type=script&lang=js"
export * from "./ToggleCard.vue?vue&type=script&lang=js"

import "./ToggleCard.vue?vue&type=style&index=0&id=be867d4a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be867d4a"]])

export default __exports__